export enum LoyaltyManagerTabsEnum {
  PROMO_CODE_MANAGER = 'promo-code-manager',
  UPSELL_MANAGER = 'upsell-manager',
}
